import React from 'react';
import { motion } from 'framer-motion';
export function Achievements() {
  const achievements = [{
    emoji: '👕',
    title: 'Vender productos sublimados y DTF desde la primera semana',
    desc: 'Con imágenes listas para imprimir y cobrar, sin depender de terceros.'
  }, {
    emoji: '🎯',
    title: 'Producir con seguridad y sin improvisar',
    desc: 'Usando imágenes probadas y compatibles con producción real.'
  }, {
    emoji: '📲',
    title: 'Publicar y vender por redes sociales con más confianza',
    desc: 'Siempre tendrás contenido visual listo para atraer clientes.'
  }, {
    emoji: '💸',
    title: 'Convertir tu impresora en un negocio que factura',
    desc: 'Y dejar de verla como una máquina parada.'
  }];
  return <section className="py-14 md:py-16 bg-[#0a0e1a]" data-id="element-14">
      <div className="max-w-[980px] mx-auto px-4" data-id="element-15">
        <motion.h2 initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-[24px] md:text-[32px] font-black text-center mb-12 uppercase text-white" data-id="element-16">
          ¿Qué vas a lograr con el{' '}
          <span className="text-[#f5a623]" data-id="element-17">Kit Sublimación y DTF Viral?</span>
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-18">
          {achievements.map((item, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          scale: 0.97
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.08
        }} className="glass-card p-6" data-id="element-19">
              <div className="text-4xl mb-4" data-id="element-20">{item.emoji}</div>
              <h3 className="text-lg md:text-xl font-bold text-white mb-2" data-id="element-21">
                {item.title}
              </h3>
              <p className="text-[17px] text-gray-400" data-id="element-22">{item.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}